import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * @desc add new subscription
 */
export function newSubscriptionAction(data) {
    return function (dispatch){
        return APIUtil.postMethod(UrlConstants.newSubscriptionUrl, data, true).then(response => {
          if(response.status == code.OK) {
            dispatch( {
                type: types.ADD_SUBSCRIPTION,
                subscriptionData: response.data
            });
        }
        else {
            dispatch( {
                type: types.ADD_SUBSCRIPTION,
                subscriptionData: response.data
            });
        }
            return response;
        });
    }
}
/**
 * @desc Subscription - upload image
 */
export function uploadImageAction(data,uploadedFiles) {  
	
    return function (dispatch){
      return APIUtil.postFormDataMethod(UrlConstants.uploadSubscriptionDocUrl, data, true,uploadedFiles).then(response => {         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.UPLOAD_DOC,
                  uploadSuccess: true 
			  });
			  
          }
          else {
              dispatch( {
                  type: types.UPLOAD_DOC,
                  uploadSuccess: false
			  });
			 
		  }
		  return response;
      });
    }  
}

/**
 * @desc Subscription - get All
 */
export function getAllSubscriptionAction(type) {  

    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.getSubscriptionUrl + type, false).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_SUBSCRIPTION,
                  subscriptions: response.data
              });
          }
          else {
              dispatch({
                  type: types.GET_ALL_SUBSCRIPTION,
                  subscriptions: []
              });
          }
          return response;
      });
    }  
}
/**
 * 
 * @desc Delete image api call
 */
export function deleteImageAction(data) {  

    return function (dispatch){
      return APIUtil.deleteMethod(UrlConstants.deleteImgUrl, true,data).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.DELETE_IMAGE,
                  isImageDeleted: true
              });
          }
          else {
              dispatch( {
                  type: types.DELETE_IMAGE,
                  isImageDeleted: false
              });
          }
          return response;
      });
    }  
}
/**
 * 
 * @desc Update subscription
 */
export function updateSubscriptionAction(data) {

    return function (dispatch){
        return APIUtil.putMethod(UrlConstants.updateSubscriptionUrl+data._id, data, true).then(response => { 
            if(response.status == code.OK) {      
                dispatch( {
                    type: types.UPDATE_SUBSCRIPTION,
                });
            }
            else {
                dispatch( {
                    type: types.UPDATE_SUBSCRIPTION
                });
            }    
           
           return response;      
                 
        });
    } 
}
/**
 * 
 * @desc Delete image api call
 */
export function removeProductAction(id) {  

    return function (dispatch){
      return APIUtil.deleteMethod(UrlConstants.removeProductUrl+id, true).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.REMOVE_PRODUCT,
                  isProductDeleted: true
              });
          }
          else {
              dispatch( {
                  type: types.REMOVE_PRODUCT,
                  isProductDeleted: false
              });
          }
          return response;
      });
    }  
}
/**
 * 
 * @desc active/inactive subscription
 */
export function archiveSubscriptionAction(id) {

    return function (dispatch){
        return APIUtil.putMethod(UrlConstants.archiveSubscriptionUrl+id, "" ,true).then(response => { 
            if(response.status == code.OK) {      
                dispatch( {
                    type: types.ARCHIVE_SUBSCRIPTION,
                });
            }
            else {
                dispatch( {
                    type: types.ARCHIVE_SUBSCRIPTION
                });
            }    
           
           return response;      
                 
        });
    } 
}
/**
 * @desc Subscription - get detail
 */
export function getSubscriptionDetail() {  

    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.getAccountInfoUrl, true).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.ACCOUNT_INFO,
                  accountInfo: response.data
              });
          }
          else {
              dispatch({
                  type: types.ACCOUNT_INFO,
                  accountInfo: []
              });
          }
          return response;
      });
    }  
}
/**
 * 
 * @desc cancel subscription
 */
export function cancelSubscriptionAction() {

    return function (dispatch){
        return APIUtil.putMethod(UrlConstants.cancelSubscriptionUrl, "" ,true).then(response => { 
            if(response.status == code.OK) {      
                dispatch( {
                    type: types.CANCEL_SUBSCRIPTION,
                });
            }
            else {
                dispatch( {
                    type: types.CANCEL_SUBSCRIPTION
                });
            }    
           
           return response;      
                 
        });
    } 
}
/**
 * @desc Subscription - get invoice list
 */
export function getInvoiceListAction() {  

    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.invoiceListUrl, true).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.INVOICE_LIST,
                  invoiceList: response.data
              });
          }
          else {
              dispatch({
                  type: types.INVOICE_LIST,
                  invoiceList: []
              });
          }
          return response;
      });
    }  
}